import * as _ from "lodash";

import {WB_CompanyRow, WB_DistribChannelRow, WB_DivisionRow, WB_SalesAreaRow, WB_SalesOrgRow} from "../PAdbSchemaRows";
import {PAdbContext} from "../PAdbContext";
import * as AsyncLock from 'async-lock';
import {esWB_Company, esWB_DistribChannel, esWB_Division, esWB_SalesArea, esWB_SalesOrg} from "../PAdbSchema";

// API to traverse Enterprise Structure
//-- Company
//-- SalesOrg
//-- SalesArea - Division - DistribChannel


export class EnterpriseUtils {

    private static dctCompanyByWbId: { [id: number]: WB_CompanyRow } = {}
    private static dctSalesOrgByWbId: { [id: number]: WB_SalesOrgRow } = {}
    private static dctDivisionByWbId: { [id: number]: WB_DivisionRow } = {}
    private static dctDistribChannelByWbId: { [id: number]: WB_DistribChannelRow } = {}
    private static dctSalesAreaByWbId: { [id: number]: WB_SalesAreaRow } = {}

    private static Lock = new AsyncLock({})
    private static dbContext: PAdbContext

    private static getDbContext(): PAdbContext {
        if (!_.isEmpty(EnterpriseUtils.dbContext))
            return EnterpriseUtils.dbContext

        EnterpriseUtils.dbContext = new PAdbContext()
        return EnterpriseUtils.dbContext
    }

    static async getSalesArea(wbSalesAreaId: number): Promise<WB_SalesAreaRow>{

        let lockKey = `SA-${wbSalesAreaId}`
        return await EnterpriseUtils.Lock.acquire<WB_SalesAreaRow>(lockKey, async (done): Promise<void> => {
            if(wbSalesAreaId in EnterpriseUtils.dctSalesAreaByWbId){
                done(undefined, EnterpriseUtils.dctSalesAreaByWbId[wbSalesAreaId])
                return
            }
            if((+wbSalesAreaId == 0) || (!_.isNumber(+wbSalesAreaId))){
                done(undefined, undefined)
                return
            }

            let dbContext = EnterpriseUtils.getDbContext()
            let sa = <WB_SalesAreaRow> await dbContext.find(esWB_SalesArea, wbSalesAreaId)
            EnterpriseUtils.dctSalesAreaByWbId[wbSalesAreaId] = sa
            done(undefined, sa)
        })
    }

    static async getCompany(wbCompanyId: number): Promise<WB_CompanyRow>{

        let lockKey = `CO-${wbCompanyId}`
        return await EnterpriseUtils.Lock.acquire<WB_CompanyRow>(lockKey, async (done): Promise<void> => {
            if(wbCompanyId in EnterpriseUtils.dctCompanyByWbId){
                done(undefined, EnterpriseUtils.dctCompanyByWbId[wbCompanyId])
                return
            }
            if((+wbCompanyId == 0) || (!_.isNumber(+wbCompanyId))){
                done(undefined, undefined)
                return
            }

            let dbContext = EnterpriseUtils.getDbContext()
            let so = <WB_CompanyRow> await dbContext.find(esWB_Company, wbCompanyId)
            EnterpriseUtils.dctCompanyByWbId[wbCompanyId] = so
            done(undefined, so)
        })
    }


    static async getSalesOrg(wbSalesOrgId: number): Promise<WB_SalesOrgRow>{

        let lockKey = `SO-${wbSalesOrgId}`
        return await EnterpriseUtils.Lock.acquire<WB_SalesOrgRow>(lockKey, async (done): Promise<void> => {
            if(wbSalesOrgId in EnterpriseUtils.dctSalesOrgByWbId){
                done(undefined, EnterpriseUtils.dctSalesOrgByWbId[wbSalesOrgId])
                return
            }
            if((+wbSalesOrgId == 0) || (!_.isNumber(+wbSalesOrgId))){
                done(undefined, undefined)
                return
            }

            let dbContext = EnterpriseUtils.getDbContext()
            let so = <WB_SalesOrgRow> await dbContext.find(esWB_SalesOrg, wbSalesOrgId)
            EnterpriseUtils.dctSalesOrgByWbId[wbSalesOrgId] = so
            done(undefined, so)
        })
    }

    static async getDivision(wbDivisionId: number): Promise<WB_DivisionRow>{

        let lockKey = `Div-${wbDivisionId}`
        return await EnterpriseUtils.Lock.acquire<WB_DivisionRow>(lockKey, async (done): Promise<void> => {
            if(wbDivisionId in EnterpriseUtils.dctDivisionByWbId){
                done(undefined, EnterpriseUtils.dctDivisionByWbId[wbDivisionId])
                return
            }
            if((+wbDivisionId == 0) || (!_.isNumber(+wbDivisionId))){
                done(undefined, undefined)
                return
            }

            let dbContext = EnterpriseUtils.getDbContext()
            let dv = <WB_DivisionRow> await dbContext.find(esWB_Division, wbDivisionId)
            EnterpriseUtils.dctDivisionByWbId[wbDivisionId] = dv
            done(undefined, dv)
        })
    }

    static async getDistribChannel(wbDistribChannelId: number): Promise<WB_DistribChannelRow>{

        let lockKey = `Dist-${wbDistribChannelId}`
        return await EnterpriseUtils.Lock.acquire<WB_DistribChannelRow>(lockKey, async (done): Promise<void> => {
            if(wbDistribChannelId in EnterpriseUtils.dctDistribChannelByWbId){
                done(undefined, EnterpriseUtils.dctDistribChannelByWbId[wbDistribChannelId])
                return
            }
            if((+wbDistribChannelId == 0) || (!_.isNumber(+wbDistribChannelId))){
                done(undefined, undefined)
                return
            }
            let dbContext = EnterpriseUtils.getDbContext()
            let dc = <WB_DistribChannelRow> await dbContext.find(esWB_DistribChannel, wbDistribChannelId)
            EnterpriseUtils.dctDistribChannelByWbId[wbDistribChannelId] = dc
            done(undefined, dc)
        })
    }



}